import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ReviewAnswers() {
    const { t } = useTranslation();
    const { state } = useLocation();
    const navigate = useNavigate();
    const { questions, selectedAnswers } = state || {};

    if (!questions || !selectedAnswers) {
        return <div>{t("No data available to review.")}</div>;
    }

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <section className="answers-page relative py-[40px]">
            <div className="container">
                <h2 className="text-[30px] font-bold text-[#09778E] mb-5">{t("Review Your Answers")}</h2>
                <div className="questions-list">
                    {questions.map((question, index) => {
                        const isAnswerSelected = selectedAnswers[index] !== undefined;
                        const isSelectedAnswerCorrect = isAnswerSelected && selectedAnswers[index] === question.passAnswers;

                        return (
                            <div key={index} className="question my-[10px] flex flex-col gap-[10px]">
                                <div className="bg-white p-2.5 font-bold rounded-[4px] text-[19px]">
                                    {question.questionId}) {t(`${question.questionsTitle}`)}
                                </div>
                                <ul className="flex flex-col gap-[10px]">
                                    {question.answers.map((answer, i) => {
                                        const isThisAnswerSelected = selectedAnswers[index] === answer;
                                        const isThisAnswerCorrect = answer === question.passAnswers;

                                        // تحديد لون الخلفية بناءً على الحالة
                                        let backgroundColor = ''; // اللون الافتراضي (بدون خلفية)
                                        if (isThisAnswerSelected) {
                                            // إذا كانت الإجابة مختارة
                                            backgroundColor = isSelectedAnswerCorrect ? 'bg-green-500' : 'bg-red-500';
                                        } else if (isThisAnswerCorrect && !isSelectedAnswerCorrect) {
                                            // إذا كانت الإجابة صحيحة ولكن ليست مختارة
                                            backgroundColor = 'bg-green-500';
                                        }

                                        return (
                                            <li key={i} className="answer-option">
                                                <label
                                                    className={`flex items-center gap-2.5 p-2.5 border border-[#808080] rounded-[4px] ${
                                                        backgroundColor ? backgroundColor + ' text-white' : ''
                                                    }`}
                                                >
                                                    <input
                                                        type="radio"
                                                        name={`question-${index}`}
                                                        value={answer}
                                                        checked={isThisAnswerSelected}
                                                        disabled
                                                    />
                                                    <div>{t(`${answer}`)}</div>
                                                </label>
                                            </li>
                                        );
                                    })}
                                </ul>
                                {selectedAnswers[index] === undefined && (
                                    <p className="text-red-500">{t("No answer selected for this question.")}</p>
                                )}
                            </div>
                        );
                    })}
                </div>
                <div className="back-btn mt-5">
                    <button
                        onClick={handleBack}
                        className="w-fit bg-[#09778E] py-[10px] px-[30px] rounded-[50px] font-bold text-center capitalize mx-auto text-white"
                    >
                        {t("Back")}
                    </button>
                </div>
            </div>
        </section>
    );
}